module.exports = __webpack_public_path__ + "img/salami-funghi.4da0023c.png";